(function (angular) {
	'use strict';

	angular
		.module('ravenModule', [])
		.value('Raven', Raven);
})(window.angular);